<c-navigation slot="sub" active>
  <a [routerLink]="['/release/view']" slot="primary-items" routerLinkActive="active">Packages</a>
  <a [routerLink]="['/release/export']" slot="primary-items" routerLinkActive="active">Label</a>
</c-navigation>
